import * as React from 'react';

import { GetCatalogProductViewQuery } from '@notino/shared/definitions/types';

import { dispatchTrackingEvent } from '@context/tracking/utils';
import { useUser } from '@queries/useUser';

export const useTrackPageView = (
  variant: NonNullable<
    GetCatalogProductViewQuery['productDetailByCatalogMasterId']
  >['variants'][number]
) => {
  const { user } = useUser();

  React.useEffect(() => {
    dispatchTrackingEvent({
      event: 'page_view',
      page: {
        path: window.location.pathname,
        title: variant.metaData.title ?? '',
        type: 'product',
        unified_name: `product-${variant.productCode}`,
        subpage: undefined,
      },
      _clear: true,
    });
  }, [variant.productCode, variant.metaData.title, user]);
};
